export type AIScanVideoUploadModalVariant = 'origin' | 'add';

/** Prototype `VID_COPY` — one picker, two entry points (Step 1 vs populated draft). */
export const SCAN_VIDEO_UPLOAD_MODAL_COPY: Record<
  AIScanVideoUploadModalVariant,
  { eyebrow: string; title: string; subtitle: string }
> = {
  origin: {
    eyebrow: 'Scope Origination',
    title: 'Upload a walkthrough video',
    subtitle: 'Kai analyzes the footage and drafts a scope for your review.',
  },
  add: {
    eyebrow: 'Add to scope',
    title: 'Upload another video',
    subtitle: 'Kai analyzes the footage and adds to the scope you already have.',
  },
};
